export const ButtonTemplate = `{{{text}}}`;
